import { get } from 'lodash';
import { OwnershipReasonEnum } from '../enum/ownership-reason.enum';
import { Owner } from './Owner.model';
import { Occupier } from './Occupier.model';

export class Eligibility {

  change_ownership_reason?: OwnershipReasonEnum;
  hdb_ref                ?: string;
  owners                 ?: Owner[];
  occupiers              ?: Occupier[];
  uinfin                 ?: string;

  constructor(initial?: any) {
    this.uinfin                = get(initial, 'uinfin', '');
    this.change_ownership_reason = get(initial, 'change_ownership_reason', '');
    this.hdb_ref                 = get(initial, 'hdb_ref', '');
    this.owners                  = get(initial, 'owners',                  []);
    this.occupiers               = get(initial, 'occupiers',               []);
  }
  
}
